<template>
  <label
    class="billet-body--selector_container"
    :class="{ active: checked }"
  >
    <input
      name="selector-option"
      type="radio"
      :checked="checked === true"
      @click="onClick"
    >
    <div class="billet-body--selector_container__item">
      <AssetV3
        :dir="iconDir"
        :name="iconName"
      />
      <span class="description">{{ name }}</span>
    </div>
    <div class="billet-body--selector_container__item">
      <span class="checkmark"></span>
    </div>
  </label>
</template>

<script>
import AssetV3 from '@/components/common/AssetV3.vue';

export default {
  name: 'Selector',
  components: { AssetV3 },
  props: {
    name: {
      type: String,
      required: true,
    },
    iconName: {
      type: String,
      required: true,
    },
    iconDir: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick(value) {
      this.$emit('click', value);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/scss/__new-styles.scss';

  .billet-body--selector_container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    border: 1px solid var(--gray-300);
    border-radius: 8px;
    height: 48px;
    width: 100%;
    padding-left: 12px;
    padding-right: 12px;
    margin-bottom: 20px;
    cursor: pointer;

    -webkit-tap-highlight-color: transparent;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    input {
      display: none;
      opacity: 0;
    }

    .checkmark {
      width: 20px;
      height: 20px;
      background-color: $gray-100;
      border-radius: 50%;
      border: 1px solid $gray-300;
    }
    input:checked~div>.checkmark {
      background-color: $white;
      border: 5px solid $primary-500;
    }

    &:hover {
      border: 1px solid var(--blue-300);

      &:not(.active) {
        img {
          filter:
            invert(52%)
            sepia(73%)
            saturate(434%)
            hue-rotate(149deg)
            brightness(94%)
            contrast(86%);
        }
        .description {
          color: var(--primary);
        }
      }
    }

    &.active {
      background-color: var(--blue-100);
      border: 1px solid var(--blue-300);

      .description {
        font-weight: bold;
      }
    }
  }

  .billet-body--selector_container__item {
      display: flex;
      align-items: center;

      .description {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        padding-left: 12px;
      }

      img {
        filter: invert(42%) sepia(28%) saturate(262%)
        hue-rotate(166deg) brightness(98%) contrast(89%);
      }
    }
</style>
